<template>
    <div>
        <section class="q10__jumbotron flex flex-col md:flex-row">
            <image-with-descriptions
                style="margin: 0; margin-bottom:1.25rem; "
                :options="{
                    image2:
                        'pages/' +
                        currentPage.slug +
                        '/' +
                        currentPage.images.oImage1.src,
                    descriptions: [
                        {
                            text: currentPage.images.oImage1.alt,
                            position: 'bottom-right', // top/bottom-left/right
                            orientation: 'horizontal', // vertical, horizontal
                        },
                         {
                            text: currentPage.images.oImage1.text,
                            position: 'bottom-left', // top/bottom-left/right
                            orientation: 'horizontal', // vertical, horizontal
                        },
                    ],
                }"
            />
            <image-with-descriptions style="margin: 0; margin-bottom:1.25rem;"
                        :options="{
                            image:
                                'pages/' +
                                currentPage.slug +
                                '/' +
                                currentPage.images.oImage2.src,
                            descriptions: [
                                {
                                    text: currentPage.images.oImage2.alt,
                                    position: 'bottom-right', // top/bottom-left/right
                                    orientation: 'horizontal', // vertical, horizontal
                                },
                                {
                                    text: currentPage.images.oImage2.text,
                                    position: 'bottom-left', // top/bottom-left/right
                                    orientation: 'horizontal', // vertical, horizontal
                                },
                            ],
                        }"
                    />

        </section>
        <div class="page">
            <div class="container px-11 2xl:px-3 mb-14 m-auto">
                <title-s-chapter
                    :options="{
                        from: 'from-allports',
                        to: 'to-resolution_blue',
                    }"
                >
                    <h1 v-html="currentPage.content.sArticleTitle.text"></h1>
                </title-s-chapter>
                
                <div class="container-components">
                    
                    <div class="card relative" style="margin-bottom: 0;">
                        <div
                            class="
                                q10__article_container__content__paragraphs
                                relative
                            "
                        >
                            <template
                                v-for="(paragraph, idx_paragraph) in currentPage
                                    .content.sParagraphOne_Content_01.text"
                            >
                                <template v-if="idx_paragraph === 0">
                                    <paragraph-first-letter-big style="margin-left: 0;"
                                        :options="{
                                            letter: paragraph.substr(0, 1),
                                            color: 'text-allports',
                                        }"
                                    />

                                    <paragraph :options="{}" class="inline">
                                        <span class="text-nandor inline"
                                            v-html="paragraph.slice(1)"
                                        ></span>
                                        
                                    </paragraph>
                                    <router-link
                                        :to="{
                                            name: 'catalogue',
                                            params: { slug: 'page-026' },
                                        }"
                                        v-html="
                                            currentPage.content
                                                .sParagraphOne_Content_03.text
                                        "
                                    ></router-link>
                                    <span class="text-base md:text-lg"
                                        v-html="
                                            currentPage.content
                                                .sParagraphOne_Content_02.text
                                        "
                                    >
                                    </span>
                                </template>
                                
                            </template>
                            
                            <!-- <div class="relative pt-10">
                                <hotspot-richmedia
                                    :options="{
                                        icon: 'diaporama',
                                        collection: getRichmediaByCollection(
                                            currentPage,
                                            'Branle-bas de combat à Tuillères'
                                        ),
                                    }"
                                    class="bottom-5 md:bottom-10 xl:bottom-5 right-2"
                                />
                            </div> -->
                        </div>
                    </div>
                    
                </div>
                <TitleParagraph
                    :options="{
                        from: 'from-allports',
                        to: 'to-resolution_blue',
                    }"
                >
                    <p
                        class="text-2xl lg:text-4xl 2xl:text-7xl mt-12"
                        v-html="currentPage.content.sSubTitleOne.text"
                    ></p>
                </TitleParagraph>
                <div class="container-components">
                <div class="card break-inside-avoid mt-0 pt-0">
                        
                        <div class="relative pt-10">
                            <hotspot-richmedia
                                :options="{
                                    icon: 'diaporama',
                                    collection: getRichmediaByCollection(
                                        currentPage,
                                        'Conduites forcées : de l’innovation dans les tuyaux'
                                    ),
                                }"
                                class="top-0 md:-top-2 right-2"
                            />
                        </div>

                        <paragraph
                            :options="{
                                color: 'text-nandor',
                            }"
                        >
                            <span
                                v-html="
                                    currentPage.content.sParagraphTwo_Content
                                        .text
                                "
                            ></span>
                            <!-- <square
                                :options="{
                                    from: 'from-allports',
                                    to: 'to-resolution_blue',
                                }"
                            /> -->
                        </paragraph>
                       
                    </div>
                     <div class="relative">
                            <image-with-descriptions
                                :options="{
                                    image:
                                        'pages/' +
                                        currentPage.slug +
                                        '/' +
                                        currentPage.images.oImage3.src,
                                    descriptions: [
                                        {
                                            text: currentPage.images.oImage3.edf,
                                            position: 'bottom-right', // top/bottom-left/right
                                            orientation: 'horizontal', // vertical, horizontal
                                        },
                                    ],
                                }"
                            />
                            <hotspot-richmedia
                                :options='{
                        icon: "diaporama",
                        collection:  [
                                        {
                                            "src": getSpecificURL() + "fr/richmedia/page-029/alea_112_01_pragneres.mp4",
                                            "type": "html5video",
                                            "caption": "Chantier de Pragnères",
                                            "thumb": getSpecificURL() + "fr/images/thumbs/faire_face_aux_aleas_techniques/resized_pragniers.jpg",
                                        },
                                        {
                                            "src": getSpecificURL() + "fr/richmedia/page-029/amoa_83_master_pradieres_decryptage_dune_success_story_st.mp4",
                                            "type": "html5video",
                                            "caption": "Remplacement de la conduite forcée à Pradières (2019-2021)",
                                            "thumb": getSpecificURL() + "fr/images/thumbs/faire_face_aux_aleas_techniques/3_2_equipe_de_choc_pour_story.jpg"
                                        }
                                    ] 
                                }'
                                class="top-2 right-2"
                            />
                        </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import PagesMixin from "@/mixins/PagesMixin";
import TitleSChapter from "../../components/TitleSChapter.vue";
import Triangles from "../../components/Triangles.vue";
import TitleParagraph from "../../components/TitleParagraph.vue";
import Paragraph from "../../components/Paragraph.vue";
import ImageWithDescriptions from "../../components/ImageWithDescriptions.vue";
import ParagraphFirstLetterBig from "../../components/ParagraphFirstLetterBig.vue";

export default {
    components: {
        TitleSChapter,
        Triangles,
        TitleParagraph,
        ImageWithDescriptions,
        Paragraph,
        ParagraphFirstLetterBig,
    },
    name : "PageTest",
    mixins: [PagesMixin],
};
</script>

<style scoped lang='scss'>
</style>
